import React, { useState, useRef } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Dropdown from 'react-bootstrap/Dropdown';
import { Label } from 'reactstrap';
import './TauriSearchResultDetailModal.css';
import config from '../../appURL.json';
import setting from '../../config.json';
import { useEffect } from 'react';
import TauriHostContainer from '../TauriHostContainer/TauriHostContainer';
import { getData } from '../../visualizations/visualizations';
import TauriFilter from '../TauriBreadcrumbs/TauriFilter/TauriFilter';

const TauriSearchResultDetailModal = ({ show, onHide, item, style }) => {
    const [isMaximized, setIsMaximized] = useState(false);
    const modalContentRef = useRef(null);
    const [itemSections, setItemSections] = useState([]);
    const [chartPalettes, setChartPalettes] = useState([]);
    const [chartThemes, setChartThemes] = useState([]);
    const [applicationItems, setApplicationItems] = useState([]);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [selectedApp, setSelectedApp] = useState(null);
    const [selectedCode, setSelectedCode] = useState(null);
    const [selectedType, setSelectedType] = useState(null);
    const [userAccessDetails, setUserAccessDetails] = useState([]);
    const [displayCode, setDisplayCode] = useState('ALL');
    const [shouldRefresh, setShouldRefresh] = useState(false);
    const [accessType, setAccessType] = useState(null);

    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

    const ACCESS_TYPE_MAP = {
        customers: { type: "customers", key: "CustomerCode", value: 8 },
        agents: { type: "agents", key: "AgentCode", value: 1 },
        districts: { type: "districts", key: "DistrictManagerCode", value: 2 },
        territories: { type: "territories", key: "AgentCode", value: 0 },
        distributors: { type: "distributors", key: "DistributorCode", value: 3 },
        regions: { type: "regions", key: "RegionCode", value: 4 },
        items: { type: "items", key: "ItemCode", value: 10 },
        customergroups: { type: "c-groups", key: "CustomerGroup", value: 0 },
        itemgroups: { type: "p-groups", key: "ItemGroupCode", value: 9 }
    };

    const extractCode = (text) => {
        const parts = text.split('-');
        return parts.length > 1 ? parts.slice(1).join('-') : text;
    };

    const extractCodeEmployee = (text) => {
        const parts = text.split('|');
        return parts.length > 1 ? parts.slice(1).join('|') : text;
    };

    useEffect(() => {

        if (item) {
            const url = new URL(item.access_path, window.location.origin);
            const pathParts = url.pathname.split('/').filter(Boolean);
            const accesstype = pathParts[pathParts.length - 1];

            const accesscode = item.identifier;
            const accessDetails = Object.values(ACCESS_TYPE_MAP).find(item => item.type === accesstype);
            setAccessType(accessDetails?.value || -1);

            let access_codes = accesscode?.split(',') || [];
            setUserAccessDetails(access_codes); // Set access details

            const initialCode = access_codes.length > 0 ? access_codes[0].trim() : '';

            localStorage.setItem('code', accessDetails.key);
            localStorage.setItem('accesscode', initialCode);

            setDisplayCode(initialCode);
            setSelectedCode(initialCode);
            setSelectedType(accessDetails.value);

            fetchSectionItems(accessDetails?.value || '');
        }
    }, [item]);

    useEffect(() => {
        fetchAppList();
    }, [selectedApp, selectedType]);

    useEffect(() => {
        // Cleanup function to clear localStorage when modal is closed
        if (!show) {
            localStorage.removeItem('code');
            localStorage.removeItem('accesscode');
        }
    }, [show]);

    const fetchAppList = async () => {
        if (selectedApp) {
            try {
                const data = await getData(selectedApp.id.toString(), selectedType.toString());
                const colorsheme = await getData('colorScheme', selectedType.toString());
                setItemSections(data.sections);
                setChartPalettes(colorsheme.palettes);
                setChartThemes(colorsheme.themes);
            } catch (error) {
                console.error("Failed to fetch export list", error);
            }
        }
    };

    const fetchSectionItems = async (type) => {
        const applicationData = await getData('applicationdashboard', type.toString());
        setApplicationItems(applicationData.applications);

        if (applicationData.applications.length > 0 && !selectedApp) {
            setSelectedApp(applicationData.applications[0]);
        }
    };

    const handleMaximizeClick = () => {
        setIsMaximized(true);
    };

    const handleRestoreClick = () => {
        setIsMaximized(false);
    };

    const handleCodeChange = (code) => {
        if (code === 'ALL') {
            setSelectedCode(userAccessDetails);
            setDisplayCode('ALL');
            localStorage.getItem('ToMonth');
            localStorage.setItem('accesscode', userAccessDetails.toString());
        } else {
            setSelectedCode([code]);
            setDisplayCode(code);
            localStorage.setItem('accesscode', code);
        }

        setShouldRefresh(prev => !prev);
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            className={`searchresult-modal-visual ${isMaximized ? 'maximized' : ''} resizable`}
            style={style}
            centered>
            <Modal.Header className="searchresult-modal-header">
                <div className="d-flex flex-column w-100">
                    <div className="d-flex">
                        <div className="chart-title">
                            <Label className="label_code">
                                (
                                {
                                    accessType === ACCESS_TYPE_MAP.customers.value ?
                                        extractCode(displayCode) :
                                        accessType === ACCESS_TYPE_MAP.agents.value ?
                                            extractCodeEmployee(displayCode) :
                                            displayCode
                                }
                                )
                            </Label>
                            <Label className="label_name">{item?.header || ''}</Label>
                        </div>
                        <div className="ms-auto d-flex">
                            {isMaximized ? (
                                <Button className='button-minimize align-items-center d-none d-xl-flex' variant='light' onClick={handleRestoreClick}>
                                    <img src={process.env.PUBLIC_URL + "/Images/arrow-minimize.svg"} alt="Icon"/>
                                </Button>
                            ) : (
                                <Button className='button-maximize align-items-center d-none d-xl-flex' variant='light' onClick={handleMaximizeClick}>
                                    <img src={process.env.PUBLIC_URL + "/Images/arrow-maximize.svg"} alt="Icon"/>
                                </Button>
                            )}
                            <Button className='button-close' variant='light' onClick={onHide}>
                                <img src={process.env.PUBLIC_URL + "/Images/material-symbols--close.svg"} alt="Icon"/>
                            </Button>
                        </div>
                    </div>
                    <div className='filter-section d-flex flex-column flex-lg-row'>
                        <div className='section-view'>
                            <Label>View :</Label>
                            <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                                <Dropdown.Toggle caret>
                                    {selectedApp ? selectedApp.name : 'Select Dashboard'}
                                </Dropdown.Toggle>
                                <Dropdown.Menu className='dropdown-menu dropdown-menu-end'>
                                    {applicationItems.map((app) => (
                                        <Dropdown.Item
                                            key={app.id}
                                            onClick={() => setSelectedApp(app)}
                                        >
                                            {app.name}
                                        </Dropdown.Item>
                                    ))}
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                        <div className='section-date'>
                            <TauriFilter onTrigger={shouldRefresh} />
                            {userAccessDetails.length > 0 && userAccessDetails[0] !== '' && (
                                <Dropdown className="codes-filters mr-3">
                                    <Dropdown.Toggle variant="secondary" id="codeDropdown">
                                        {
                                            (
                                                accessType === ACCESS_TYPE_MAP.customers.value ?
                                                    extractCode(displayCode) :
                                                    accessType === ACCESS_TYPE_MAP.agents.value ?
                                                        extractCodeEmployee(displayCode) :
                                                        displayCode
                                            ) || 'ALL'
                                        }
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={() => handleCodeChange('ALL')}>ALL</Dropdown.Item>
                                        {userAccessDetails.map((code, index) => {
                                            const displayCode = code.trim(); // Trim whitespace from the code
                                            return (
                                                <Dropdown.Item key={index} onClick={() => handleCodeChange(displayCode)}>
                                                    {accessType === ACCESS_TYPE_MAP.customers.value
                                                        ? extractCode(displayCode)
                                                        : accessType === ACCESS_TYPE_MAP.agents.value
                                                            ? extractCodeEmployee(displayCode)
                                                            : displayCode}
                                                </Dropdown.Item>
                                            );
                                        })}
                                    </Dropdown.Menu>
                                </Dropdown>
                            )}
                        </div>
                    </div>
                </div>
            </Modal.Header>
            <Modal.Body
                ref={modalContentRef}
                className="searchresult-modal-body" style={{
                    height: `${setting.hostSectionHeight}rem`,
                }}>
                <TauriHostContainer itemSection={itemSections} chartPalette={chartPalettes} chartTheme={chartThemes} />
            </Modal.Body>
            <Modal.Footer className='searchresult-modal-footer'>
            </Modal.Footer>
        </Modal>
    );
};

export default TauriSearchResultDetailModal;
